// Cookie/analytics consent store. Analytics is optional (never essential). Persisted in localStorage.
const KEY = "de_consent_v1";
const MAX_AGE_MS = 365 * 24 * 60 * 60 * 1000; // expired or missing consent is treated as "not decided", never as acceptance
const listeners = new Set();

export function getConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    const value = raw ? JSON.parse(raw) : null; // { analytics: boolean, at: iso }
    if (!value?.at || Date.now() - Date.parse(value.at) > MAX_AGE_MS) return null;
    return value;
  } catch {
    return null;
  }
}

export function setConsent(analytics) {
  const value = { analytics: Boolean(analytics), at: new Date().toISOString() };
  try { localStorage.setItem(KEY, JSON.stringify(value)); } catch { /* ignore */ }
  listeners.forEach((fn) => fn(value));
  return value;
}

export function onConsentChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

let openPrefs = null;
export const registerPreferencesOpener = (fn) => { openPrefs = fn; };
export const openCookiePreferences = () => openPrefs?.();
